import {
  addDays,
  addMonths,
  addWeeks,
  addYears,
  endOfMonth,
  endOfWeek,
  endOfYear,
  isSameDay,
  startOfMonth,
  startOfWeek,
  startOfYear,
} from 'date-fns'

// eslint-disable-next-line no-unused-vars
import { DefinedRange } from './types'

export const getRangeLabel = (
  startDate: Date,
  endDate: Date,
  locale?: Locale,
  showAllTime?: boolean,
): string => {
  const ranges = getDefaultRanges(new Date(), locale, showAllTime)
  for (let range of ranges) {
    if (
      isSameDay(range.startDate, startDate) &&
      isSameDay(range.endDate, endDate)
    ) {
      return range.label
    }
  }

  // If no matching range is found, return a default label
  return `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`
}

export const getDefaultRanges = (
  date: Date,
  locale?: Locale,
  showAllTime?: boolean,
): DefinedRange[] => {
  const ranges = [
    {
      label: 'Today',
      startDate: date,
      endDate: date,
    },
    {
      label: 'Yesterday',
      startDate: addDays(date, -1),
      endDate: addDays(date, -1),
    },
    {
      label: 'This Week',
      startDate: startOfWeek(date, { locale }),
      endDate: endOfWeek(date, { locale }),
    },
    {
      label: 'Last Week',
      startDate: startOfWeek(addWeeks(date, -1), { locale }),
      endDate: endOfWeek(addWeeks(date, -1), { locale }),
    },
    {
      label: 'Last 7 Days',
      startDate: addWeeks(date, -1),
      endDate: date,
    },
    {
      label: 'This Month',
      startDate: startOfMonth(date),
      endDate: endOfMonth(date),
    },
    {
      label: 'Last Month',
      startDate: startOfMonth(addMonths(date, -1)),
      endDate: endOfMonth(addMonths(date, -1)),
    },
    {
      label: 'This Year',
      startDate: startOfYear(date),
      endDate: endOfYear(date),
    },
    {
      label: 'Last Year',
      startDate: startOfYear(addYears(date, -1)),
      endDate: endOfYear(addYears(date, -1)),
    },
    {
      label: 'All Time',
      startDate: new Date(0),
      endDate: new Date(),
    },
  ]

  if (showAllTime) {
    ranges.push({
      label: 'All Time',
      startDate: new Date(0),
      endDate: new Date(),
    })
  }

  return ranges
}
